//any type checked blueice
import { AttendanceType } from './../enum/attendanceType.enum';

export interface ICourseStudentAttendance {
    id: string;
    info?: AttendanceInfo;
    calendarEventId?: string;
    courseId?: string;
    eventDate?: Date;
    eventStartTime?: string;
    eventEndTime?: string;
    eventTitle?: string;
    eventLocation?: string;
    academicPeriodId?: string;
    schoolId?: string;
}

export class CourseStudentAttendance implements ICourseStudentAttendance {
    constructor(
        public id: string,
        public info?: AttendanceInfo,
        public calendarEventId?: string,
        public courseId?: string,
        public eventDate?: Date,
        public eventStartTime?: string,
        public eventEndTime?: string,
        public eventTitle?: string,
        public eventLocation?: string,
        public academicPeriodId?: string,
        public schoolId?: string
    ) {
        this.id = id ? id : null;
        this.info = info ? info : new AttendanceInfo();
        this.calendarEventId = calendarEventId ? calendarEventId : null;
        this.courseId = courseId ? courseId : null;
        this.eventDate = eventDate ? eventDate : null;
        this.eventStartTime = eventStartTime ? eventStartTime : null;
        this.eventEndTime = eventEndTime ? eventEndTime : null;
        this.eventTitle = eventTitle ? eventTitle : null;
        this.eventLocation = eventLocation ? eventLocation : null;
        this.academicPeriodId = academicPeriodId ?? null;
        this.schoolId = schoolId ?? null;
    }
}

export class AttendanceInfo {
    constructor(
        public type?: AttendanceType,
        public note?: string,
        public parentMessage?: string,
        public headTeacherMessage?: string,
        public displayNoteToStudent?: boolean,
        public studentId?: string,
        public durationTardy?: number,
        public joinTime?: Date,
        public leftTime?: Date,
        public duration?: number,
        public durationInSeconds?: number,
        public saved?: boolean,
        public recordingViewed?: boolean,
        public recordingViewDuration?: number,
        public canceled?: boolean,
        public code?: string,
        public marked?: boolean
    ) {
        this.type = type ? type : AttendanceType.PRESENT;
        this.note = note ? note : null;
        this.displayNoteToStudent = displayNoteToStudent ? displayNoteToStudent : false;
        this.studentId = studentId ? studentId : null;
        this.durationTardy = durationTardy ? durationTardy : 0;
        this.joinTime = joinTime ? joinTime : null;
        this.leftTime = leftTime ? leftTime : null;
        this.duration = duration ? duration : null;
        this.durationInSeconds = durationInSeconds ? durationInSeconds : null;
        this.saved = saved ?? false;
        this.recordingViewed = recordingViewed ? recordingViewed : false;
        this.recordingViewDuration = recordingViewDuration ? recordingViewDuration : 0;
        this.canceled = canceled ?? false;
        this.code = code ?? null;
        this.marked = marked ? marked : false;
    }
}

export class BulkSaveAttendanceInfo extends AttendanceInfo {
    constructor(
        public markOthersType?: AttendanceType,
        public otherDurationTardy?: number,
        public isMarkOthersChecked?: boolean
    ) {
        super();
        this.markOthersType = markOthersType ? markOthersType : null;
        this.otherDurationTardy = otherDurationTardy ? otherDurationTardy : null;
        this.isMarkOthersChecked = isMarkOthersChecked ? isMarkOthersChecked : false;
    }
}
